const getDefaultState = () => ({
  countries: [],
});

const state = getDefaultState();

export default state;

export { getDefaultState };
